<template>
<v-container>
    <div class="d-flex justify-end">
        <v-breadcrumbs :items="breadItems" divider=">"></v-breadcrumbs>
    </div>
    <!-- <app-loading v-if="object===null"></app-loading> -->
    <v-row>
        <v-col sm="12" md="4" lg="3">
            <v-card min-height="350px" class="border-radius-10">
                <v-row>
                    <v-col cols="12">
                        <div class="user-profile">
                            <div class="user-profile__avatar">
                                <!-- <v-img :src="(typeof tutor_profile_pic != 'undefined' && tutor_profile_pic != null) ? object.tutor_profile_pic : 'img/default_user.png'" class="user-profile__photo"></v-img> -->
                                <v-img :src="(tutor_profile.tutor_profile_pic != null) ?  tutor_profile.tutor_profile_pic : 'img/default_user.png'" class="user-profile__photo"></v-img>
                            </div>
                        </div>

                        <div class="user-info">
                            <div class="user-info__name">{{tutor_profile.tutor_fname}} {{tutor_profile.tutor_lname}}</div>
                            <div class="user-info__email">{{tutor_profile.tutor_email}}</div>
                            <div class="user-info__phone">{{tutor_profile.tutor_contactno}}</div>
                        </div>

                        <div class="tutor-info">
                            <div class="tutor-info__subjects">
                                <v-chip outlined color="primary" v-for="(subject, index) in tutor_profile.tutor_subject_group" :key="index">
                                    {{subject.subject.subject_name}}
                                </v-chip>
                            </div>
                            <div class="tutor-info__rating">
                                <!-- <v-rating
                                            v-model="tutor_profile.ratting"
                                            background-color="#F2A711 lighten-3"
                                            color="#F2A711"
                                            readonly
                                            dense
                                            medium
                                    ></v-rating> -->
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <v-col sm="12" md="8" lg="9">
            <v-card min-height="100%" class="border-radius-10" style="padding: 12px;">
                <v-row class="box-style">
                    <v-col md="6">
                        <div class="tutor-details border-right">
                            <h2 class="tutor-details__heading">About Tutor</h2>
                            <v-simple-table class="tutor-details__table" dense>
                                <template v-slot:default>
                                    <tbody>
                                        <tr>
                                            <th class="item-name">Full Name</th>
                                            <td class="item-value text-right">{{ tutor_profile.tutor_fname }} {{ tutor_profile.tutor_lname }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="item-name">Email</th>
                                            <td class="item-value text-right">{{ tutor_profile.tutor_email }}</td>
                                        </tr>
                                        <tr>
                                            <th class="item-name">Contact Number</th>
                                            <td class="item-value text-right">{{ tutor_profile.tutor_contactno }}</td>
                                        </tr>
                                        <tr>
                                            <th class="item-name">Address</th>
                                            <td class="item-value text-right">{{ tutor_profile.tutor_street_address }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>

                    <v-col md="6">
                        <div class="tutor-details">
                            <!-- <h2 class="tutor-details__heading">Schedule</h2> -->
                            <v-simple-table class="tutor-details__table" dense>
                                <template v-slot:default>
                                    <tbody>
                                        <!-- <tr>
                                            <th class="item-name">Subjects</th>
                                            <td class="item-value text-right">
                                                  <v-chip color="primary" v-for="(subject, index) in tutor_profile.tutor_subject_group" :key="index" :id="subject.subject_id">
                                        {{subject.subject.subject_name}}
                                    </v-chip>
                                            </td>
                                        </tr> -->
                                        <!-- <tr>
                                            <th class="item-name">Week Days</th>
                                            <td class="item-value text-right">
                                                <v-chip v-for="day in tutor_profile.days" :key="day">{{days_formatter(day)}}
                                                </v-chip>
                                            </td>
                                        </tr> -->
                                        <!-- <tr>
                                            <th class="item-name">Time</th>
                                            <td class="item-value text-right">
                                                <v-chip>{{tutor_profile.time}}</v-chip>
                                            </td>
                                        </tr> -->
                                        <tr>
                                            <th class="item-name">Per Hour Rate</th>
                                            <td class="item-value text-right">
                                                <v-chip>{{tutor_profile.tutor_per_hour_rate}}</v-chip>
                                            </td>
                                        </tr>
                                         <tr>
                                            <th class="item-name">Joining Date</th>
                                            <td class="item-value text-right" v-if="tutor_profile.joining_date != null">
                                                {{ dateConverter(tutor_profile.joining_date) }}
                                            </td>
                                            <td class="item-value text-right" v-else>
                                                - / - / - 
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>
                </v-row>

                <v-row class="box-style">
                    <v-col md="12">
                        <div class="tutor-details">
                            <h2 class="tutor-details__heading">Bank Details</h2>
                            <v-simple-table class="tutor-details__table bank" dense>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>Bank Name</th>
                                            <th>Account Title</th>
                                            <th>Account Number</th>
                                            <th>Sort Code</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {{tutor_profile.tutor_bankname}}
                                            </td>
                                            <td>
                                                {{tutor_profile.tutor_account_title}}
                                            </td>
                                            <td>
                                                {{tutor_profile.tutor_accountno}}
                                            </td>
                                            <td>
                                                {{tutor_profile.tutor_sortcode}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>
                </v-row>

                <!-- <v-row>
                        <v-col md="6">
                            <div class="lecture-detail">
                                <h3 class="lecture-detail__title">Delivered</h3>
                                <div class="lecture-detail__box">
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value">34</div>
                                        <div class="lecture-detail__name">Total Lectures</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value">25 hr</div>
                                        <div class="lecture-detail__name">Total Time</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value">£ 300</div>
                                        <div class="lecture-detail__name">Paid Amount</div>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <v-col md="6">
                            <div class="lecture-detail">
                                <h3 class="lecture-detail__title">Remaining</h3>
                                <div class="lecture-detail__box remaining">
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value remaining">25</div>
                                        <div class="lecture-detail__name">Total Lectures</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value remaining">20 hr</div>
                                        <div class="lecture-detail__name">Total Time</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value remaining">£ 250</div>
                                        <div class="lecture-detail__name">Unpaid Amount</div>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row> -->
            </v-card>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import AppLoading from "../../AppLoading";
import moment from "moment";

export default {
    name: "TutorProfile",
    components: {
        AppLoading
    },
    data() {
        return {
            tutor_profile: {},
            object: null, // earlier this object was using where i am using tutor_profile i think thes key is reserved
            rating: 4,
            breadItems: [{
                    text: "Dashboard",
                    disabled: false,
                    href: "/",
                    to: {
                        name: "DashBoard"
                    }
                },
                {
                    text: "TUTOR",
                    disabled: false,
                    to: {
                        name: "TPTutorProfile"
                    }
                }
            ],
            about: [{
                    name: "Full Name",
                    value: "John Doe"
                },
                {
                    name: "Email Address",
                    value: "johndoe@gmail.com"
                },
                {
                    name: "Contact Number",
                    value: "+9203401234567"
                },
                {
                    name: "Address",
                    value: "House no 123, Street 12, Bahira Orchard, Lahore"
                }
            ],

            schedule: [{
                    name: "Subjects",
                    value: "Computer Science"
                },
                {
                    name: "Week days",
                    value: "Tues, Thurs, Sunday"
                },
                {
                    name: "Time",
                    value: "1:00 PM to 3:00 PM"
                },
                {
                    name: "Per hour rate",
                    value: "£ 25"
                }
            ],

            bank: [{
                    name: "Subjects",
                    value: "Computer Science"
                },
                {
                    name: "Week days",
                    value: "Tues, Thurs, Sunday"
                },
                {
                    name: "Time",
                    value: "1:00 PM to 3:00 PM"
                },
                {
                    name: "Per hour rate",
                    value: "£ 25"
                }
            ]
        };
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('user'));
        let tutor_id = user
        if (tutor_id) {
            axios.get(apiRoutes.tutors.tutorpanel.profile + '/' + user.id).then(response => {
                this.tutor_profile = response.data ;
            })
        }
    },
    methods:{
        dateConverter(date){
            return moment(date).format("DD-MM-YYYY")
        }
    }
};
</script>

<style lang="scss" scoped>
.box-style {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 10px;
}

.border-radius-10 {
    border-radius: 10px;
}

.border-right {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.user-profile {
    height: 160px;
    margin-top: -12px;
    background: #f1efef;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: relative;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    &__avatar {
        max-height: 120px;
        overflow: hidden;
        width: 120px;
        border-radius: 50%;
        border: 1px solid #6a158e;
        padding: 2px;
        margin-bottom: -20px;
    }
}

.user-info {
    margin-top: 40px;
    text-align: center;

    &__name {
        font: 500 18px/22px Gotham;
        color: #172b4d;
    }

    &__email,
    &__phone {
        font: 400 14px/22px Gotham;
        color: #3f475d99;
    }
}

.tutor-info {
    text-align: center;
    padding: 10px 18px;
    margin-top: 30px;
    border-top: 0.5px solid #d6dbe1;
    // border-left: 0;
    // border-right: 0;
    // border-bottom: 0;

    &__subjects {
        font: 400 15px/25px Gotham;
        color: #6a158e;
    }
}

.tutor-details {
    &__heading {
        font: Bold 20px/25px Lato;
        color: #3f475d;
    }

    &__table {
        margin-top: 10px;

        & th.item-name {
            width: 40%;
            border-bottom: none !important;
            padding-left: 0;
            font: 500 14px/13px Gotham;
            color: #3f475d;
        }

        & td.item-value {
            border-bottom: none !important;
            font: 400 14px/13px Lato;
            color: #3f475d99;
        }

        &.bank {
            & th.item-name {
                width: auto;
            }

            & td.item-value {
                padding-left: 0;
            }
        }
    }
}

.lecture-detail {
    &__title {
        text-align: center;
        font: 500 15px/25px Gotham;
        color: #172b4d;
    }

    &__box {
        padding: 20px 10px;
        border: 1px solid #12a630;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    &__desc {
        text-align: center;
    }

    &__value {
        font: 500 18px/30px Gotham;
        color: #12a630;
    }

    &__name {
        font: 500 10px/13px Gotham;
        color: #3f475d;
    }

    &__box.remaining {
        border-color: #0ebddff7;
    }

    &__value.remaining {
        color: #0ebddff7;
    }
}

.student-class {
    padding: 10px 18px;
    margin-top: 30px;
    border: 0.5px solid #d6dbe1;
    border-left: 0;
    border-right: 0;

    &__info {
        display: flex;
        justify-content: space-between;

        &-title {
            font: 500 14px/20px Gotham;
            color: #172b4d;
        }

        &-value {
            font: 300 14px/13px;
            font-family: "Gotham Narrow";
            color: #8898aa;
        }
    }
}

.student-subjects {
    padding: 10px 18px;
    margin-top: 15px;

    &__btn {
        margin-bottom: 10px;
    }
}
</style>
